import isEqual from 'lodash/isEqual'

import React from 'react'
import Icon from 'components/ui/icon'
type Props = {
  field: string
  metadata: Record<string, any>
  originalMetadata: Record<string, any> | null | undefined
}

const ChangeIndicator = ({
  field,
  metadata,
  originalMetadata,
}: Props): null | React.ReactNode => {
  if (!originalMetadata || isEqual(metadata[field], originalMetadata[field]))
    return null
  return <Icon type="check" color="#5f63ee" width={12} height={12} />
}

export default ChangeIndicator
